import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {CoreModule} from "../core/core.module";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import {TypeaheadModule} from 'ngx-bootstrap/typeahead';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {PlaySpaceService} from "../shared/services/playspace.service";
import {ChatModule} from "../chat/chat.module";
import {EventDetailComponent} from "./event-detail/event-detail.component";
import {EventListComponent} from "./event-list/event-list.component";
import {EventService} from "../shared/services/event.service";
import {PlayerEventInfoService} from "../shared/services/playereventinfo.service";
import {PopoverModule} from 'ngx-bootstrap/popover';
import {PlayerModule} from "../player/player.module";
import {RouterModule} from "@angular/router";
//import {NgxLoadingModule} from 'ngx-loading';
import {EventPlayersComponent} from "./event-players/event-players.component";
import {EventPlayerManagementComponent} from "./event-player-management/event-player-management.component";
import {GroupByPipe} from "../shared/pipes/group.pipe";
import {SortByPipe} from "../shared/pipes/sort.pipe";
import {SortGroupedByPipe} from "../shared/pipes/sortGrouped.pipe";
import { NgxSpinnerModule } from "ngx-spinner";
import { GoogleMapsModule } from "@angular/google-maps";
import { AppModule } from "app/app.module";
import { TimezonePipe } from "app/shared/pipes/timezone.pipe";
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from '../shared/i18n/localized-date.pipe';
import { RatingReviewComponent } from "./rating-review/rating-review.component";
import { GuestOwnerComponent } from "./guest-owner/guest-owner.component";
import { PublicEventInviteComponent } from "./public-event-invite/public-event-invite.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { StatsService } from "../shared/services/stats.service";
import { NogoshIconPipe } from "../shared/icons/nogosh-icon.pipe";
import { LoadingProgressComponent } from "../shared/loading-progress/loading-progress.component";
import { ScreenShellComponent } from "../shared/screen-shell/screen-shell.component";
import { GuestAppDownloadsComponent } from "./guest-flow/guest-app-downloads.component";
import { GuestMatchHeaderComponent } from "./guest-flow/guest-match-header.component";
import { GuestMatchInfoGridComponent } from "./guest-flow/guest-match-info-grid.component";
import { GuestParticipantListComponent } from "./guest-flow/guest-participant-list.component";
import { GuestParticipantSectionHeaderComponent } from "./guest-flow/guest-participant-section-header.component";
import { GuestProfileNudgeComponent } from "./guest-flow/guest-profile-nudge.component";
import { GuestUpgradeComponent } from "./guest-upgrade/guest-upgrade.component";

import { MatchHomeComponent } from "./match-home/match-home.component";
import { InviteLinkSheetComponent } from './invite-link-sheet.component';
import { TeamBoardComponent } from "./team-board/team-board.component";

@NgModule({
  declarations: [InviteLinkSheetComponent, TeamBoardComponent, MatchHomeComponent, EventDetailComponent, GroupByPipe, SortByPipe, SortGroupedByPipe, EventListComponent, EventPlayersComponent, EventPlayerManagementComponent, TimezonePipe, RatingReviewComponent, GuestOwnerComponent, PublicEventInviteComponent, GuestUpgradeComponent, NotificationsComponent, GuestAppDownloadsComponent, GuestMatchHeaderComponent, GuestMatchInfoGridComponent, GuestParticipantListComponent, GuestParticipantSectionHeaderComponent, GuestProfileNudgeComponent],
  imports: [CommonModule, 
    FormsModule, 
    CoreModule,
    BsDatepickerModule, 
    TimepickerModule, 
    TypeaheadModule, 
    BsDropdownModule, 
    ChatModule,
    PopoverModule, 
    PlayerModule, 
    RouterModule, 
    //   NgxLoadingModule.forRoot({}),
    NgxSpinnerModule,
    GoogleMapsModule,
    TranslateModule,
    LocalizedDatePipe,
    NogoshIconPipe,
    LoadingProgressComponent,
    ScreenShellComponent
  ],
  exports: [EventListComponent],
  providers: [EventService, PlaySpaceService, PlayerEventInfoService, StatsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventModule {
}
